import React from "react";
import { useTranslation } from "react-i18next";
import { Close } from "@dreamhub/designsystem/icons";
import Text from "@/components/ui/text";
import { formatIsoDate } from "@/utils/datetime";
import DreamerIcons from "./DreamerIcons";
import ResponseSources from "./ResponseSources";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import { IconButton } from "@/components/ui/icon-button";
import PopoverWrapper from "../PopoverWrapper";
import { BaseIndicationProps, IndicationData } from "../types";
import { usePopoverState } from "../hooks";

const TRANSLATION_KEY = "deals.dealView.filledByDreamer";

interface Props extends BaseIndicationProps {
  indicationData: IndicationData;
}

const DreamerModeIndication: React.FC<Props> = ({
  dealId,
  questionResponse,
  showSources = true,
  size,
  indicationData
}) => {
  const { t } = useTranslation();
  const { isPopoverOpen, setIsPopoverOpen } = usePopoverState();

  const { indicationDate } = indicationData;
  const filledAt = formatIsoDate(indicationDate);

  const getIndicationText = () => t(`${TRANSLATION_KEY}.filledByDreamer`);

  const triggerContent = (
    <DreamerIcons
      dreamerMode={true}
      isLastEditedByDreamer={true}
      lastEditedByData={undefined}
      previousLastEditedBy={null}
      size={size}
    />
  );

  const popoverContent = (
    <>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex items-center">
            <DreamerIcons
              dreamerMode={true}
              isLastEditedByDreamer={true}
              lastEditedByData={undefined}
              previousLastEditedBy={null}
              size="md"
            />
          </div>
          <Text variant="lgLabel">{getIndicationText()}</Text>
        </div>
        <div className="flex items-center gap-4">
          {filledAt ? <Text variant="bodyTertiary">{filledAt}</Text> : null}
          <IconButton
            aria-label={t("close")}
            onClick={() => setIsPopoverOpen(false)}
            variant="iconNoBg"
            iconColor="secondary"
            size="md"
          >
            <Close />
          </IconButton>
        </div>
      </div>
      {showSources ? (
        <ResponseSources
          entityType={EntityType.DEAL}
          entityId={dealId}
          response={questionResponse?.response}
        />
      ) : null}
    </>
  );

  return (
    <PopoverWrapper
      isPopoverOpen={isPopoverOpen}
      setIsPopoverOpen={setIsPopoverOpen}
      triggerContent={triggerContent}
      tooltipText={getIndicationText()}
      popoverContent={popoverContent}
    />
  );
};

export default DreamerModeIndication;
